<template>
  <div class="bg-pattern-gray client-form-wrap">
    <div class="dashboard-body-content d-flex justify-content-center align-items-center p-5">
      <div class="client-columns">
        <div class="form-wrap">
          <div class="card card-form">
            <div class="card-header">
              <div class="card-title">Add New Client</div>
            </div>
            <div class="card-body">
              <h5 class="form-title">Enter Client Details</h5>

              <form @submit.prevent="handleSubmit">
                <div class="field">
                  <input type="text" id="comp_name" v-model="form.full_name" class="form-control"
                    :class="{ invalid: errors.full_name }" placeholder="Name/Company Name*" />
                  <div class="error-msg" :class="{ show: errors.full_name }">
                    {{ errors.full_name }}
                  </div>
                </div>

                <div class="contact-row">
                  <div class="contact-fields">
                    <div class="field">
                      <input type="email" id="email" v-model="form.email" class="form-control"
                        :class="{ invalid: errors.email }" placeholder="Email address*" />
                      <div class="error-msg" :class="{ show: errors.email }">
                        {{ errors.email }}
                      </div>
                    </div>
                    <div class="field">
                      <div class="phone-row">
                        <select id="dial_code" v-model="form.dial_code" @change="handleDialCodeChange" class="dial-select"
                          title="Country dial code">
                          <option value="">&#x1F4DE; Code</option>
                          <option v-for="c in dialCountries" :value="c.code" :key="c.iso">
                            {{ c.iso }} +{{ c.code }}
                          </option>
                        </select>
                        <input type="tel" id="phone_no" v-model="form.phone1" @input="formatPhone" placeholder="Phone no"
                          maxlength="21" />
                      </div>
                    </div>
                  </div>
                  <div class="initials-box" id="initialsBox" aria-hidden="true">
                    <span v-if="!initials" class="placeholder-text">Add More</span>
                    <template v-else>{{ initials }}</template>
                  </div>
                </div>

                <div class="toggle-wrap">
                  <button type="button" class="btn btn-toggle" :class="{ open: showMore }" @click="showMore = !showMore"
                    :aria-expanded="showMore" aria-controls="formMore" title="Show/hide details">
                    <img class="chev"
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAB80lEQVQ4jZ3TTUiUURTG8Z++E0mfaEa0MoxEKYUyCXFhH6uiQgNDohAxghJS+qaiLygoCAkqWhhIFC3MVpbLbBOYUEGQkUEthSZTMbF0mhbzTowgjvbAWdxzn/O/l3vOZXZqwtHZGDNm4WnEUOhdgrszmTPTwI4gjkd4GEIPz1QQzLB3CPNwJyXXiwqU4E2ay0xRPY4lF2e2JSJFx1E3W9h+nEouGsuJdyWisXyK7zT2pYPtxTlhs+pKibcTvxdGeyIXKjP01qQCUpuyB4W4jnhNMW0nMYxRI0YNGU7kaorBH9xAEaqTkOTY7MJGXMOv7Wt4fhnjGPRJYBKBmLgchbLYcZGufpCFs3iNzgxUoQxXMVa5iu4r4flRfQL5mB8ePCnmo1zrZLL5Ai+/goVJaCYW4SbGKvLoPh+WRvUIFCA35VlyBNaKekXCW5EHfoaMxf9+SkMZrU2YxDfdIiqxFCOmKhuDJr2w3FYRDt7ifm9KU2pLaT2BCUR1hbAV08DgB1aK2CKq00SitnZD2JSWKpp3h2825KlANfLxZRpYqlbjs5gnstWIcamDjPhjfMe4BwIHUID+NLCkivBBTJss9ZYRMQBuh7CSOcCgD+sF3powbEBzBK1okJjD93OAJfUOm9CDBRnxFr8lJv3Zf8BStRMdfwEYbogKIVrLkAAAAABJRU5ErkJggg=="
                      alt="" />
                  </button>
                </div>

                <div class="more-fields" :class="{ open: showMore }" id="formMore">
                  <div class="field">
                    <input type="text" id="biz_name" v-model="form.business_name" class="form-control"
                      placeholder="Business Name (opt)" />
                  </div>
                  <div class="field">
                    <input type="text" id="postal_address" v-model="form.postal_address" class="form-control"
                      placeholder="Postal address / Street 1" />
                  </div>
                  <div class="field">
                    <input type="text" id="address2" v-model="form.street2" class="form-control" placeholder="Street 2" />
                  </div>
                  <div class="row-2col">
                    <div class="field wide">
                      <select v-model="form.state" class="form-select">
                        <option value="" selected disabled>County/State</option>
                        <option v-for="option in state_options" :value="option.name" :key="option.id">
                          {{ option.name }}
                        </option>
                      </select>
                    </div>
                    <div class="field">
                      <input type="text" id="zipCode" v-model="form.zip" @input="formatZipCode" class="form-control"
                        placeholder="Zip/Postal Code" />
                    </div>
                  </div>
                  <div class="field">
                    <select v-model="form.country" @change="handleCountryChange" class="form-select">
                      <option value="" selected disabled>Country</option>
                      <option v-for="option in country_options" :value="option.name" :key="option.id">
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                  <div class="field">
                    <textarea id="formNote" v-model="form.notes" class="form-control" placeholder="Notes..."></textarea>
                  </div>
                </div>

                <div class="form-footer">
                  <button type="button" class="btn btn-cancel" @click="$router.push({ name: 'list-clients' })">
                    Cancel
                  </button>
                  <button type="submit" class="btn btn-next" :disabled="loading">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <AddressMap :street1="form.postal_address" :state="form.state" :zip="form.zip" :country="form.country" />
      </div>
    </div>
  </div>
</template>
<script>
import { COUNTRIES_LIST } from "../../config/url";
import { DIAL_COUNTRIES, DIAL_GROUPS, DEFAULT_GROUPS } from "../../config/dialCodes";
import AddressMap from "../partials/AddressMap.vue";

export default {
  name: "AddClient",
  components: { AddressMap },
  data() {
    return {
      loadingInstance: null,
      loading: false,
      countries: null,
      states: null,
      business_categories: null,
      showMore: true,
      dialCountries: DIAL_COUNTRIES,
      activeDial: null,
      form: {
        full_name: "",
        email: "",
        business_name: "",
        dial_code: "",
        phone1: "",
        phone2: "",
        country: "",
        postal_address: "",
        street1: "",
        state: "",
        zip: "",
        notes: "",
        website: "",
      },
      errors: {},
    };
  },

  computed: {
    pageTitle() {
      return (document.title = `${this.title
        ? this.title.replace(/\b\w/g, (match) => match.toUpperCase())
        : "Add Client"
        } | Smoothbalance`);
    },
    country_options() {
      if (this.countries) {
        return this.countries.map((v) => {
          return {
            id: v.id,
            name: v.name,
          };
        });
      }
      return [];
    },
    state_options() {
      if (this.states) {
        return this.states.map((v) => {
          return {
            id: v.id,
            name: v.name,
          };
        });
      }
      return [];
    },
    initials() {
      const name = this.form.full_name ? this.form.full_name.trim() : "";
      if (!name) return "";
      return name
        .split(/\s+/)
        .map((w) => w.replace(/[^A-Za-z0-9]/g, ""))
        .filter(Boolean)
        .map((w) => w[0].toUpperCase())
        .slice(0, 2)
        .join("");
    },
  },
  created() {
    this.runMountedFunctions();
  },
  methods: {
    async runMountedFunctions() {
      // 1. Fetch countries and wait for it to finish
      await this.fetchCountries();

      // 2. Set the user's country
      const userCountryId = this.$store.state.auth.user.country_id;
      const userCountry = this.countries.find((c) => c.id === userCountryId);
      if (userCountry) {
        this.form.country = userCountry.name;

        // Sync dial code
        const countryData = this.dialCountries.find((c) => c.name === userCountry.name);
        if (countryData) {
          this.form.dial_code = String(countryData.code);
          this.activeDial = String(countryData.code);
        }

        // 3. Fetch states for this country
        await this.fetchStateByCountry();
      }
    },
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    async fetchCountries() {
      try {
        const res = await this.axios.get(COUNTRIES_LIST);
        this.countries = res.data.response;
        return this.countries; // <-- return the data so await works
      } catch (err) {
        console.log(err);
        return []; // optional fallback
      }
    },
    fetchStateByCountry() {
      this.showLoading();
      let country_id = this.countries.find(
        (country) => country.name === this.form.country
      );

      this.$store
        .dispatch("client/fetchStateByCountry", { country_id: country_id.id })
        .then((res) => {
          if (res.status == 1) {
            this.states = res.response;
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    handleDialCodeChange() {
      const selectedCode = this.form.dial_code;
      if (!selectedCode) return;
      this.activeDial = String(selectedCode);

      // Sync standard Country select if a country list is loaded
      const countryData = this.dialCountries.find(
        (c) => String(c.code) === String(selectedCode)
      );
      if (countryData) {
        const matchedCountry = this.country_options.find(
          (opt) => opt.name === countryData.name
        );
        if (matchedCountry) {
          this.form.country = matchedCountry.name;
          this.fetchStateByCountry();
        }
      }
      // Always apply prefix immediately on dial code selection
      this.applyDialPrefix();
    },
    handleCountryChange() {
      this.fetchStateByCountry();

      const countryName = this.form.country;
      const countryData = this.dialCountries.find((c) => c.name === countryName);
      if (countryData) {
        this.form.dial_code = String(countryData.code);
        this.activeDial = String(countryData.code);
      }
      // Always apply prefix immediately on country selection
      this.applyDialPrefix();
    },
    // Apply the +XX prefix to the phone field; keeps any digits already typed
    applyDialPrefix() {
      if (!this.activeDial) return;
      const v = this.form.phone1 || "";
      // Strip any existing dial prefix (any +digits at the start), keep national digits
      const national = v.replace(/^\+\d+\s?/, "").replace(/[^0-9]/g, "");
      const prefix = "+" + this.activeDial + " ";
      if (national) {
        const groups = DIAL_GROUPS[this.activeDial] || DEFAULT_GROUPS;
        this.form.phone1 = (prefix + this.groupDigits(national, groups)).slice(0, 21);
      } else {
        // Set prefix even for empty input so user can type the number directly
        this.form.phone1 = prefix;
      }
    },
    formatZipCode() {
      if (this.form.zip) {
        this.form.zip = this.form.zip.replace(/[^A-Za-z0-9 ]/g, "");
      }
    },
    // Called on every keystroke in the phone input
    formatPhone() {
      let v = this.form.phone1 || "";

      if (this.activeDial) {
        const prefix = "+" + this.activeDial;
        // Strip the dial prefix to get just the national digits
        const national = v
          .replace(new RegExp("^\\+" + this.activeDial + "\\s?"), "")
          .replace(/[^0-9]/g, "");
        if (!national) {
          // User cleared everything — restore just the prefix so they can keep typing
          this.form.phone1 = prefix + " ";
          return;
        }
        const groups = DIAL_GROUPS[this.activeDial] || DEFAULT_GROUPS;
        this.form.phone1 = (prefix + " " + this.groupDigits(national, groups)).slice(
          0,
          21
        );
        return;
      }

      // No dial code chosen yet — free-form rules (digits, + , space only)
      v = v.replace(/[^0-9+ ]/g, "");
      v = v.replace(/^ +/, "");
      const startsWithPlus = v.startsWith("+");
      v = v.replace(/\+/g, "");
      if (startsWithPlus) v = "+" + v;
      v = v.replace(/ {2,}/g, " ");
      v = v.replace(/^\+? +/, (m) => (m.startsWith("+") ? "+" : ""));
      this.form.phone1 = v.slice(0, 21);
    },
    groupDigits(digits, groups) {
      const parts = [];
      let i = 0;
      for (const g of groups) {
        if (i >= digits.length) break;
        parts.push(digits.slice(i, i + g));
        i += g;
      }
      // extra digits beyond the pattern: append in groups of 3
      while (i < digits.length) {
        parts.push(digits.slice(i, i + 3));
        i += 3;
      }
      return parts.join(" ");
    },
    // Simple email validation using regex
    isValidEmail(email) {
      const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return re.test(email);
    },

    // Handle form submission with validation
    handleSubmit() {
      if (this.validateForm()) {
        this.createClient();
      }
    },
    validateForm() {
      this.errors = {};

      // Check full_name is not empty
      if (!this.form.full_name) {
        this.errors.full_name = "Name/Company Name is required.";
      }

      // Check email is not empty and valid
      if (!this.form.email) {
        this.errors.email = "A valid email address is required.";
      } else if (!this.isValidEmail(this.form.email)) {
        this.errors.email = "Please enter a valid email address.";
      }

      // If there are no errors, return true (form is valid)
      return Object.keys(this.errors).length === 0;
    },
    createClient() {
      this.showLoading();
      const payload = {
        ...this.form,
        business_name: this.form.business_name || this.form.full_name,
      };
      this.$store
        .dispatch("client/createClient", payload)
        .then((res) => {
          if (res.status == 1) {
            this.$toast.success("Create client Successful.");
            this.$router.push({ name: "list-clients" }); // redirect by route name
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
};
</script>
<style scoped>
.client-form-wrap {
  --teal: #18798c;
  --teal-dark: #136374;
  --red: #e03131;
  --green: #2da44e;
  --green-dark: #248a42;
  --panel: #f0f1f2;
  --ink: #2c3038;
  --muted: #8a909a;
  --line: #d9dde2;
  --radius: 14px;
  --shadow: 0 6px 24px rgba(20, 30, 50, 0.08);

  color: var(--ink);
}

/* Form card on the left, location card beside it when a zip is present. */
.client-columns {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 28px;
  width: 100%;
}

.form-wrap {
  width: 100%;
  max-width: 560px;
}

.form-wrap .card {
  background: transparent;
  border-radius: var(--radius);
  box-shadow: none;
  overflow: visible;
  border: none;
}

.form-wrap .card-header {
  background: transparent;
  border: none;
  padding: 0;
  display: flex;
  justify-content: flex-start;
}

.form-wrap .card-form .card-header .card-title,
.form-wrap .card-header .card-title,
.form-wrap .card-title {
  background: var(--teal) !important;
  background-color: var(--teal) !important;
  color: #fff !important;
  height: 55px;
  margin: 0;
  padding: 8px 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  border-radius: 8px 8px 0 0;
  width: fit-content;
  min-width: 180px;
}

.form-wrap .card-body {
  background: var(--panel);
  border-radius: 0 8px 8px 8px;
  box-shadow: var(--shadow);
  padding: 26px 70px 28px;
}

.form-title {
  padding-left: 0 !important;
  text-align: left !important;
  margin: 0 0 18px;
  font-size: 15px;
  font-weight: 700;
  color: var(--ink);
}

.field {
  margin-bottom: 14px;
}

.form-control,
.form-select,
textarea.form-control {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #fff;
  padding: 11px 14px;
  font-size: 14px;
  color: var(--ink);
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.form-select {
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%238a909a' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round' fill='none'/%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 14px center !important;
  background-size: 12px 8px !important;
  padding-right: 38px !important;
}

.form-control::placeholder {
  color: #b6bcc6;
}

.form-control:focus,
.form-select:focus,
textarea.form-control:focus {
  border-color: var(--teal);
  box-shadow: 0 0 0 3px rgba(24, 121, 140, 0.12);
}

.form-control.invalid {
  border-color: var(--red);
}

.error-msg {
  display: none;
  color: var(--red);
  font-size: 12.5px;
  margin-top: 4px;
  text-align: left;
}

.error-msg.show {
  display: block;
}

textarea.form-control {
  min-height: 90px;
  resize: none;
}

/* Email/phone rows + Add More */
.contact-row {
  display: flex;
  gap: 12px;
}

.contact-fields {
  flex: 1;
  min-width: 0;
}

/* Phone row: flag dropdown inline with input */
.phone-row {
  display: flex;
  align-items: stretch;
  border: 1px solid var(--line);
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.phone-row:focus-within {
  border-color: var(--teal);
  box-shadow: 0 0 0 3px rgba(24, 121, 140, 0.12);
}

.dial-select {
  flex-shrink: 0;
  border: none;
  border-right: 1px solid var(--line);
  background: #f7f8f9;
  color: var(--ink);
  font-size: 13px;
  font-family: inherit;
  padding: 0 6px 0 10px;
  outline: none;
  cursor: pointer;
  min-width: 90px;
  max-width: 110px;
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%238a909a'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 7px center;
  padding-right: 22px;
}

.dial-select:focus {
  background-color: #f0f5f6;
}

.phone-row input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: var(--ink);
  padding: 11px 14px;
  min-width: 0;
}

.phone-row input::placeholder {
  color: #b6bcc6;
}

.btn {
  cursor: pointer;
}

/* Inactive box that shows the company initials */
.initials-box {
  align-self: stretch;
  flex-shrink: 0;
  width: 86px;
  border: 1px solid #c7ccd2;
  background: #e9ebee;
  color: var(--teal);
  border-radius: 8px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 52px;
  font-weight: 700;
  letter-spacing: 1px;
  user-select: none;
  pointer-events: none;
  /* inactive */
}

.initials-box .placeholder-text {
  font-size: 12px;
  font-weight: 600;
  color: var(--muted);
  letter-spacing: 0;
  text-align: center;
  padding: 0 6px;
}

/* Expand/collapse toggle */
.toggle-wrap {
  display: flex;
  justify-content: center;
  margin: 6px 0 14px;
}

.btn-toggle {
  border: none;
  background: transparent;
  padding: 6px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-toggle:hover {
  background: rgba(24, 121, 140, 0.08);
}

.btn-toggle .chev {
  width: 22px;
  height: auto;
  display: block;
  transition: transform 0.2s ease;
}

/* icon points up while open (click to collapse); flips down when closed */
.btn-toggle:not(.open) .chev {
  transform: rotate(180deg);
}

.more-fields {
  display: none;
}

.more-fields.open {
  display: block;
}

.row-2col {
  display: flex;
  gap: 12px;
}

.row-2col .field {
  flex: 1;
  min-width: 0;
}

.row-2col .field.wide {
  flex: 1.4;
}

.form-wrap .card-form .card-body .form-footer,
.form-wrap .card-body .form-footer,
.form-wrap .form-footer,
.form-footer {
  margin-top: 50px !important;
  margin-bottom: 50px !important;
  padding-top: 0 !important;
  display: flex !important;
  flex-direction: row !important;
  flex-flow: row nowrap !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 12px !important;
  width: 100% !important;
}

.btn-cancel {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
}

.btn-cancel:hover {
  background: #f4f5f6;
  color: var(--ink);
}

.btn-next {
  background: var(--green);
  border: none;
  border-radius: 8px;
  padding: 10px 30px;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  transition: background 0.15s ease;
}

.btn-next:hover {
  background: var(--green-dark);
  color: #fff;
}

.btn-next:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 991px) {
  .client-columns {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 540px) {
  .form-wrap .card-body {
    padding: 20px 20px 22px;
  }

  .row-2col {
    flex-direction: column;
    gap: 0;
  }

  .contact-row {
    flex-direction: column;
    gap: 0;
  }

  .initials-box {
    width: 100%;
    min-height: 64px;
  }

  .form-wrap .card-title {
    height: 48px;
    font-size: 16px;
    padding: 8px 20px;
  }
}
</style>
